/**
 * Shareable invite URLs: /join/<gameSegment>/<roomId>
 * e.g. /join/addata/X7K2M9 — gameSegment matches namespace without leading slash (/addata → addata).
 */
export function parseJoinPath(pathname: string): { namespace: string; roomId: string } | null {
  const m = pathname.match(/^\/join\/([^/]+)\/([^/]+)\/?$/);
  if (!m) return null;
  return { namespace: `/${m[1]}`, roomId: m[2] };
}

export function buildJoinPath(namespace: string, roomId: string): string {
  const seg = namespace.startsWith("/") ? namespace.slice(1) : namespace;
  return `/join/${seg}/${roomId}`;
}

export function absoluteJoinUrl(namespace: string, roomId: string): string {
  if (typeof window === "undefined") return buildJoinPath(namespace, roomId);
  return `${window.location.origin}${buildJoinPath(namespace, roomId)}`;
}
